import React from 'react';
import styled from 'styled-components';

import { GUID } from '@ndvr/customer-api';

import { Button } from './button';
import { CopyToClipboard } from './CopyToClipboard';
import { IconClone } from './icon';
import { HorizontalLayout } from './Layout';
import { Text } from './Text';

export const GuidDisplay = ({ guid }: { guid: GUID<any> }) => {
    return (
        <CopyToClipboard tooltip={guid} textToCopy={guid}>
            <Wrapper $rowCenter>
                <GuidText $rowCenter $center>
                    <Text>{guid.substring(0, 8)}</Text>
                </GuidText>
                <StyledCopyButton size="icon" buttonType="ghost" icon={<IconClone size="xSmall" />} />
            </Wrapper>
        </CopyToClipboard>
    );
};

const Wrapper = styled(HorizontalLayout)`
    border: 1px solid ${({ theme }) => theme.border.dark};
    border-radius: 2px;
`;

const StyledCopyButton = styled(Button)`
    padding: 2px 4px;
    position: relative;
`;

const GuidText = styled(HorizontalLayout)`
    border-right: 1px solid ${({ theme }) => theme.border.dark};
    padding: 8px;
    width: 100px;
`;
